import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// Removed Toaster import - no more global notifications
import Navbar from './components/Navbar';
import TermsNConditions from './components/TermsNConditions';
import Home from './pages/Home';
import ContactUs from './pages/ContactUs';
import AboutUs from './pages/AboutUs';
import ServiceFeatures from './components/ServiceFeatures';
import PaymentPage from './components/PaymentPage';
import Login from './components/Login';
import Signup from './components/Signup';
import VerifyOtp from './components/VerifyOtp';
import ForgotPassword from './components/ForgotPassword';
import UpdatePassword from './components/UpdatePassword';
import PaymentSuccess from './components/PaymentSuccess';
import CookieConsent from './components/CookieConsent';
import Footer from './components/Footer';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookiePolicyPage from './components/CookiePolicyPage';



// Import the new components for the multi-step payment flow
import UserDataForm from './components/UserDataForm';
import DocumentUpload from './components/DocumentUpload';
import AdminPortal from './components/AdminPortal';
import EditProfile from './components/EditProfile';



function App() {

  const whatsappNumber = '+393428439658'; // e.g., '923001234567' for Pakistan
  const whatsappMessage = 'Ciao! Ho visto il vostro sito e potete aiutarmi a scegliere la soluzione migliore per me?'; // Optional pre-filled message

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;
    window.open(url, '_blank');
  };


  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/termsNconditions" element={<TermsNConditions />} />
            <Route path="/services" element={<ServiceFeatures />} />

            <Route path="/edit-profile" element={<EditProfile />} />

            {/* Updated payment flow routes */}
            {/* Step 1: Collect user data */}
            <Route path="/services/:id/user-data" element={<UserDataForm />} />
            {/* Step 2: Upload documents */}
            <Route path="/services/:id/documents" element={<DocumentUpload />} />
            {/* Step 3: Final payment page */}
            <Route path="/services/:id/payment" element={<PaymentPage />} />

            {/* Keep the old payment route for backward compatibility if needed */}
            <Route path="/payment/:id" element={<PaymentPage />} />

            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/verify-otp" element={<VerifyOtp />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/update-password" element={<UpdatePassword />} />
            <Route path="/success" element={<PaymentSuccess />} />
            <Route path="/admin" element={<AdminPortal />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />

          </Routes>
        </main>
        <Footer />
      </div>
      <CookieConsent />

      <button
        onClick={handleWhatsAppClick}
        className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-lg transition-all duration-300 hover:scale-110 z-50"
        aria-label="Chat on WhatsApp"
      >
        <svg
          className="w-6 h-6"
          fill="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
        </svg>
      </button>



      {/* Removed global Toaster - no more toast notifications */}
    </Router>
  );
}

export default App;